import Ai from './Ai';
import Attributions from './Attributions';
import Auth from './Auth';
import Authors from './Authors';
import Base from './Base';
import Collections from './Collections';
import Comments from './Comments';
import Contests from './Contests';
import Deliveries from './Deliveries';
import Documents from './Documents';
import Groups from './Groups';
import Locations from './Locations';
import Medias from './Medias';
import Notifications from './Notifications';
import Pages from './Pages';
import Profile from './Profile';
import Promotions from './Promotions';
import Search from './Search';
import Stats from './Stats';
import Submissions from './Submissions';
import Subscriptions from './Subscriptions';
import Taxonomies from './Taxonomies';
import Timeline from './Timeline';
import Visitor from './Visitor';

interface ApiOptions {
    baseUrl?: string;
    authBaseUrl?: string;
    [key: string]: unknown;
}

class Api extends Base {
    auth: Auth;
    visitor: Visitor;
    profile: Profile;
    promotions: Promotions;
    subscriptions: Subscriptions;
    documents: Documents;
    authors: Authors;
    taxonomies: Taxonomies;
    collections: Collections;
    search: Search;
    timeline: Timeline;
    locations: Locations;
    contests: Contests;
    pages: Pages;
    submissions: Submissions;
    medias: Medias;
    deliveries: Deliveries;
    comments: Comments;
    ai: Ai;
    attributions: Attributions;
    notifications: Notifications;
    groups: Groups;
    stats: Stats;

    constructor(opts: ApiOptions = {}) {
        const options = {
            baseUrl: 'https://api.urbania.ca',
            authBaseUrl: 'https://api.urbania.ca/auth',
            ...opts,
        };
        super(options);

        const { authBaseUrl, ...authOptions } = options;

        this.auth = new Auth({
            ...authOptions,
            baseUrl: authBaseUrl,
        });
        this.visitor = new Visitor(options);
        this.profile = new Profile(options);
        this.promotions = new Promotions(options);
        this.subscriptions = new Subscriptions(options);
        this.documents = new Documents(options);
        this.authors = new Authors(options);
        this.taxonomies = new Taxonomies(options);
        this.collections = new Collections(options);
        this.search = new Search(options);
        this.timeline = new Timeline(options);
        this.locations = new Locations(options);
        this.contests = new Contests(options);
        this.pages = new Pages(options);
        this.submissions = new Submissions(options);
        this.medias = new Medias(options);
        this.deliveries = new Deliveries(options);
        this.comments = new Comments(options);
        this.ai = new Ai(options);
        this.attributions = new Attributions(options);
        this.notifications = new Notifications(options);
        this.groups = new Groups(options);
        this.stats = new Stats(options);
    }

    site(id: string, opts = null) {
        return this.getJSON<Site>(`/sites/${id}`, null, opts);
    }

    brands() {
        return this.getJSON<ApiListResponse<Brand>>('/brands');
    }
}

export default Api;
